
import { createContext, useState, useEffect } from "react";
import { io } from "socket.io-client";
import instance, { url } from "../../../../axios/instance";

const SocketContext = createContext()

const socket = io(`${url}/telemedicine`)

function SocketProvider({ children }) {

    useEffect(() => {
        goOnline()

        socket.on("disconnect", () => {
            goOffline()
        })
        
    }, [])

    const token = window.sessionStorage.getItem("ACCESS_TOKEN")


    async function goOnline() {
        instance.get("/telemedicine/go_online", {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        .then(response => {
            console.log(response.data);
        })
        .catch(error => {
            console.log(error?.response?.data || error.message)
        })
    }

    async function goOffline() {
        instance.get("/telemedicine/go_offline", {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        .then(response => {
            console.log(response.data);
        })
        .catch(error => {
            console.log(error?.response?.data || error.message)
        })
    }


    return (
        <SocketContext.Provider value={socket}>
            {children}
        </SocketContext.Provider>
    );
}

export { SocketContext, SocketProvider };
